import { Link } from "wouter";
import { SEOHead } from "../components/SEOHead";
import { FooterPixCapture } from "../components/FooterPixCapture";
import { ArrowLeft } from "lucide-react";

export default function PixCaptureAGB() {
  return (
    <div className="min-h-screen bg-[var(--color-white)] flex flex-col">
      <SEOHead
        title="AGB – pixcapture.app"
        description="Allgemeine Geschäftsbedingungen von pixcapture.app"
        path="/agb"
      />

      <header className="border-b border-[var(--color-light-grey)]">
        <div className="max-w-[1200px] mx-auto px-8 py-6">
          <div className="flex items-center gap-4">
            <Link href="/">
              <button className="hover:bg-gray-100 p-2 rounded">
                <ArrowLeft className="h-5 w-5" />
              </button>
            </Link>
            <h1 className="text-[24px] font-medium tracking-[0.05em] text-[var(--color-black)] leading-none">
              Allgemeine Geschäftsbedingungen
            </h1>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-[800px] mx-auto px-8 py-16">
          <div className="prose prose-gray max-w-none">
            <p className="text-[var(--color-grey)] mb-8">Stand: November 2024</p>

            <section className="mb-12">
              <h2>§1 Geltungsbereich</h2>
              <p className="text-[var(--color-grey)]">
                Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Leistungen von pixcapture.app
                im Bereich der Immobilienfotografie und Bildbearbeitung.
              </p>
            </section>

            <section className="mb-12">
              <h2>§2 Leistungsumfang</h2>
              <p className="text-[var(--color-grey)]">
                pixcapture.app bietet eine Plattform zum Upload, zur Bearbeitung und Bereitstellung von Immobilienfotos.
              </p>
            </section>

            <section className="mb-12">
              <h2>§3 Preise und Zahlung</h2>
              <p className="text-[var(--color-grey)]">
                Die aktuellen Preise sind auf der Website einsehbar. Zahlung erfolgt nach Upload und Bearbeitung.
              </p>
            </section>

            <section className="mb-12">
              <h2>§4 Urheberrechte</h2>
              <p className="text-[var(--color-grey)]">
                Alle Rechte an den hochgeladenen und bearbeiteten Bildern bleiben beim Kunden.
              </p>
            </section>

            <section className="mb-12">
              <h2>§5 Haftung</h2>
              <p className="text-[var(--color-grey)]">
                Wir haften nur für vorsätzliche oder grob fahrlässige Pflichtverletzungen.
              </p>
            </section>

            <div className="mt-12 pt-8 border-t border-[var(--color-light-grey)]">
              <p className="text-[var(--color-grey)] text-[14px]">
                Bei Fragen zu den AGB kontaktieren Sie uns unter: <a href="mailto:info@pixcapture.app" className="text-[var(--color-accent)]">info@pixcapture.app</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <FooterPixCapture />
    </div>
  );
}
